export enum ToggleEvents {
  TOGGLE_CHANGE = 'toggleChange',
}
